export default {
  header: '',
  item: itemTemplate,
  clearAll: 'Clear all',
  footer: ''
};

function itemTemplate(_ref) {
  var type = _ref.type,
      label = _ref.label,
      operator = _ref.operator,
      displayOperator = _ref.displayOperator,
      exclude = _ref.exclude,
      name = _ref.name,
      count = _ref.count,
      cssClasses = _ref.cssClasses;

  var computedOperator = operator ? displayOperator : '';
  var computedLabel = label ? label + ' ' + (computedOperator || ':') + ' ' : computedOperator;
  var countValue = count === undefined ? 0 : count;
  var computedCount = type === 'query' ? '' : '<span class="' + cssClasses.count + '">' + countValue + '</span>';
  var computedExclude = exclude ? '-' : '';
  var computedName = type === 'query' ? '<q>' + name + '</q>' : name;
  return computedLabel + ' ' + computedExclude + ' ' + computedName + ' ' + computedCount;
}


//////////////////
// WEBPACK FOOTER
// /Applications/MAMP/htdocs/newton/wp-content/themes/newton/node_modules/instantsearch.js/es/widgets/current-refined-values/defaultTemplates.js
// module id = 631
// module chunks = 0